import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import API from "../../../Network/API";
import { MY_COURSE_FETCH_SUCCESS } from "../../../Reducer/myCourseSlice";
import PostLoader from '../../../assets/loader.gif';
import CourseForm from "./CourseForm";
import "./CourseForm.css";

export default function EditCourse() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const select_course = useSelector((state) => state.myCourseReducer);
    const prams = useParams();
    const [data, setData] = useState();
    const [status, setStatus] = useState("loading"); // loading | ready | not_found | failed
    const [attempt, setAttempt] = useState(0);

    // resolve the course from the store, or fetch the list on refresh/deep link
    useEffect(() => {
        const found = select_course?.courses?.find(course => course.id == prams.id && course.title !== undefined);
        if (found) {
            setData(found);
            setStatus("ready");
            return;
        }
        let cancelled = false;
        setStatus("loading");
        API.get(`/v1/oauth/teacher/mycourses`).then((response) => {
            if (cancelled) return;
            dispatch(MY_COURSE_FETCH_SUCCESS(response.data.data));
            const course = response.data.data?.courses?.find(course => course.id == prams.id);
            setData(course);
            setStatus(course ? "ready" : "not_found");
        }).catch(() => {
            if (!cancelled) setStatus("failed");
        });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prams.id, attempt]);

    if (status === "loading") {
        return (
            <div className="cf-page cf-state">
                <img src={PostLoader} alt={t("courseForm.loading")} height={80} width={80} />
            </div>
        );
    }

    if (status !== "ready") {
        return (
            <div className="cf-page cf-state">
                <i className={status === "failed" ? "fa-light fa-wifi-exclamation" : "fa-light fa-book-circle-arrow-right"} />
                <h2>{status === "failed" ? t("courseForm.load_failed") : t("courseForm.not_found")}</h2>
                <p>{status === "failed" ? t("courseForm.err_network") : t("courseForm.not_found_sub")}</p>
                <div className="d-flex justify-content-center gap-2 mt-3">
                    <Link to="/dashboard/my-courses" className="btn cf-btn-ghost">{t("courseForm.back_to_courses")}</Link>
                    {status === "failed" && (
                        <button type="button" className="btn cf-btn-primary" onClick={() => setAttempt((n) => n + 1)}>
                            {t("courseForm.retry")}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    return <CourseForm key={data.id} course={data} />;
}
